// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"bddc704c","73":"f426ce51","159":"1d90c758","247":"684aa9d8","258":"1374c8fa","355":"397c7689","479":"af1482a9","481":"f9f199fa","498":"505c4895","568":"b4dbb6a5","650":"837195ff","656":"b2e7fbdb","977":"6ec3ed18"}[chunkId] + ".chunk.js";
};